/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Match_TrackerInputs */



/**
* | output |
* | --- |
* | "Match tracker" |
*
* @param {Nav_Match_TrackerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_match_tracker = /** @type {((inputs?: Nav_Match_TrackerInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Match_TrackerInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Match-Tracker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suivi de partie")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("对局记录")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("對戰計分")
	if (locale === "ko") return /** @type {LocalizedString} */ ("경기 트래커")
	return /** @type {LocalizedString} */ ("Match tracker")
});